import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Dashboard from '../views/Dashboard/Dashboard';
import Login from '../views/LoginSubModel/LoginSubModel';
import Password from '../views/PasswordSetting/PasswordSetting';
import IDP from '../views/IDPSetting/IDPSetting';
import UserMapping from '../views/IDPSetting/UserMapping';
import Application from '../views/ApplicationSetting/ApplicationSetting';
import User from '../views/UserSetting/UserSetting';
import Group from '../views/GroupSetting/GroupSetting';
import APIKey from '../views/APIKeySetting/APIKeySetting';
import Certificate from '../views/CertificateSetting/CertificateSetting';
import Email from '../views/EmailSetting/EmailSetting';
import Subadmin from '../views/Subadmin/Subadmin';
import Layout from '../views/Layout/Layout';
import PageNotFound from '../components/Common/NotFound404';
import Logs from '../views/Logs/Logs';
import ThemeConfig from '../views/ApplicationSetting/CustomThemeConfig';
import FileConfig from '../views/ApplicationSetting/FileConfig';
import NoDataPage from '../components/Common/NoDataPage';

const ProtectedRoutes = () => {
  const token = localStorage.getItem('ACCESS_TOKEN');
  const subadmin = useSelector((state) => state.common.subAdminBoolean);
  const organization = useSelector((state) => state.common.orgName);
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {!organization ? (
          <>
            {/* Allow dashboard even if organization is missing */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/subadmin" element={<Subadmin />} />

            {/* Show NoDataPage for everything else */}
            <Route path="*" element={<NoDataPage />} />
          </>
        ) : (
          <>
            {!subadmin && (
              <>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/login-setting" element={<Login />} />
                <Route path="/password-setting" element={<Password />} />
                <Route path="/idp-setting" element={<IDP />} />
                <Route path="/idp-setting/:IdpID" element={<UserMapping />} />
                <Route path="/application-setting" element={<Application />} />
                <Route path="/user-setting" element={<User />} />
                <Route path="/group-setting" element={<Group />} />
                <Route path="/apikey-setting" element={<APIKey />} />
                <Route path="/certificate-setting" element={<Certificate />} />
                <Route path="/email-setting" element={<Email />} />
                <Route path="/subadmin" element={<Subadmin />} />
                <Route path="/logs" element={<Logs />} />
                <Route
                  path="/application-setting/theme"
                  element={<ThemeConfig />}
                />
                <Route
                  path="/application-setting/file"
                  element={<FileConfig />}
                />
              </>
            )}
            <Route path="/application-setting" element={<Application />} />
            <Route path="/user-setting" element={<User />} />
            <Route path="/group-setting" element={<Group />} />
            <Route path="/logs" element={<Logs />} />
            <Route
              path="/application-setting/theme"
              element={<ThemeConfig />}
            />
            <Route key="not-found" path="*" element={<PageNotFound />} />
          </>
        )}
      </Route>
    </Routes>
  );
};

export default ProtectedRoutes;
